/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorJoinLogDto } from '../../models/vendor-join-log-dto';

export interface VendorWorkspaceJoinLogControllerJoinUser$Params {

/**
 * 워크스페이스 ID
 */
  id: string;
}

export function vendorWorkspaceJoinLogControllerJoinUser(http: HttpClient, rootUrl: string, params: VendorWorkspaceJoinLogControllerJoinUser$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorJoinLogDto>> {
  const rb = new RequestBuilder(rootUrl, vendorWorkspaceJoinLogControllerJoinUser.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorJoinLogDto>;
    })
  );
}

vendorWorkspaceJoinLogControllerJoinUser.PATH = '/api/vendorJoinLog/{id}/join';
